import request from '../../utils/request'
const queryOrder = (data) => {
    return request({
        url: process.env.VUE_APP_TRADER + `order/info/${data.type}/${data.outTrade}`,
        // url: 'http://sybao.sy.soyoung.com/' + process.env.VUE_APP_TRADER + 'order/insurance',
        method: 'get',
    })
}
const orderPay = (parme) => {
    //console.log(parme.data)
    return request({
        url: process.env.VUE_APP_TRADER + `order/pay/${parme.outTrade}`,
        // url: 'http://sybao.sy.soyoung.com/' + process.env.VUE_APP_TRADER + 'order/insurance',
        method: 'POST',
        data: parme.data
    })
}
export {
    queryOrder,
    orderPay
}